module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-19-b6ab3959d5ea12b977843e635b9fa592.svg";